import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/fe-webapp-next/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/fe-webapp-next/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea"] */ "/app/fe-webapp-next/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/fe-webapp-next/components/ui/separator.tsx");
